import PropTypes from "prop-types";

export const coordInterface = {
  fieldIndexOnPage: PropTypes.number,
  fieldName: PropTypes.string, //"<$signature>"
  isRequired: PropTypes.bool,
  page: PropTypes.number,
  pageRect: PropTypes.object, // {height: 1008, isEmpty: false, isPoint: false, isTrivial: false, llx: 0, lly: 0, urx: 612, ury: 1008, width: 612}
  rectangle: PropTypes.object,// {width: 46.696, height: 8.799999999999955, llx: 37, lly: 867.344, urx: 83.696, …}
}

export const fieldInterface = {
  coords: PropTypes.arrayOf(PropTypes.shape(coordInterface)),
  description: PropTypes.string, // "firstName"
  isCheckBox: PropTypes.bool,
  isCustom: PropTypes.bool,
  isEditable: false,
  isPresent: PropTypes.bool,
  isRequired: PropTypes.bool,
  isSignature: PropTypes.bool,
  name: PropTypes.string, //"firstName"
  occurrencesCount: PropTypes.number,
}


const contractInterface = {
  id: PropTypes.number,
  name: PropTypes.string,
  documentUrl: PropTypes.string,
  documentKey: PropTypes.string,
  isActive: PropTypes.bool,
  isDefault: PropTypes.bool,
  selected: PropTypes.bool,
  order: PropTypes.number,
  fields: PropTypes.arrayOf(PropTypes.shape(fieldInterface)),
  pagesCount: PropTypes.number,
  blobUrl: PropTypes.string, // is used in the contract sign popup
  pagesFrom: PropTypes.number, // is used in the contract sign popup
  pagesTo: PropTypes.number, // is used in the contract sign popup
}

export const documentOptions = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
};

// let response = [
//   {
//     id: 1,
//     name: "2025-Arizona-Agreement.pdf",
//     documentUrl: "http://localhost:9005/#/1",
//     documentKey: "",
//     isActive: false,
//     isDefault: true,
//     selected: false,
//     order: 1,
//     fields: "",
//   },
//   {
//     id: 2,
//     name: "2024-California-Agreement.pdf",
//     documentUrl: "http://localhost:9005/#/2",
//     documentKey: "",
//     isActive: false,
//     isDefault: false,
//     selected: false,
//     order: 2,
//     fields: "",
//   },
//   {
//     id: 3,
//     name: "2022-Texas-Agreement.pdf",
//     documentUrl: "http://localhost:9005/#/3",
//     documentKey: "",
//     isActive: false,
//     isDefault: false,
//     selected: false,
//     order: 3,
//     fields: "",
//   },
// ];

export default contractInterface
